import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import {ReactComponent as Phone} from '../../assets/new-icons/phone.svg';
import {ReactComponent as Email} from '../../assets/new-icons/email.svg';
import {ReactComponent as Coffee} from '../../assets/new-icons/coffee.svg';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as LogoWhite } from "../../assets/img/logo_esteso_wh.svg";
import { ReactComponent as Check } from "../../assets/new-icons/check_simple.svg";
import './ModificaEffettuata.scss'
import md5 from "md5";
import axios from "axios";
import { useFetchLogin } from "../../functions/login";

function Errore() {
  const navigate = useNavigate();
  const fromPath = useSelector((user) => user.settings.path);
  const [showScroll, setShowScroll] = useState(false);
  const section = useSelector((user) => user.settings.section);
  const fetchLogin = useFetchLogin();
  const metodoAggiunto = useSelector((user) => user.settings.metodoAggiunto);
  useEffect(() => {
    document.body.style.overflow = null;
    document.body.style.touchAction =  null;
    fetchLogin();
  }, []);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 120) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 120) {
      setShowScroll(false);
    }
  };
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  window.addEventListener("scroll", checkScrollTop);

  const bodyBox = {
    initial: {
      height: 0,
      bottom: -150,
      transition: {
        duration: 1.0,
        ease: [0.87, 0, 0.13, 1],
      },
    },
    animate: {
      height: "90%",
      bottom: -150,
      transition: {
        duration: 1.0,
        ease: [0.87, 0, 0.13, 1],
      },
    },
  };
  const handleTitle = () => {
    switch (fromPath) {
      case "/enrica/letture":
        return "ATTENZIONE: Autolettura non ricevuta.";
      case "/enrica/documenti":
        return "Pagamento effettuato";
      case "/enrica/profilo/aggiungi":
        return "ATTENZIONE: Nessun metodo di pagamento aggiunto";
      case "/enrica/promo":
        return "ATTENZIONE: Qualcosa è andato storto."
      default:
        return "ATTENZIONE: La tua ricarica non è andata a buona fine!";
    }
  };
  const handleSubTitle = () => {
    switch (fromPath) {
      case "/enrica/letture":
        return "Non abbiamo ricevuto la tua autolettura.";
      case "/enrica/promo":
        return "Non siamo riusciti a concludere l'operazione di ricarica 3, 6, 12.";
      case "/enrica/profilo/aggiungi":
        return "Purtroppo non siamo riusciti ad aggiungere il tuo metodo di pagamento correttamente."
      default:
        return "Purtroppo non è stato possibile effettuare la ricarica.";
    }
  };
  return (
    <div className="newPlan red">
      <div className="newPlan-top">
        <header>
          <div className="logo">
            <LogoWhite />
          </div>
        </header>
        <div className="text">
          <p className="main">{handleTitle()}</p>
        </div>
      </div>
      <div className="newPlan-bottom">
        {/* <div className="boxSwipe">
                    <p className="labelSwipe">Perfetto</p>
                    <div className="icon">
                        <Check className="check" />
                    </div>
                </div> */}
        <div className="recapInfo">
          <p className="main">{handleSubTitle()}</p>
          <p className="label" style={{ marginTop: 0 }}>
          Se non sei in grado di individuare l'errore da solo, ti aiutiamo noi!<br/>
          Contattaci e insieme con le nostre Tutor risolveremo il problema il prima possibile.          </p>
          <div className="errorItems">
            <div className="items">
              <div
                className="item"
                onClick={() =>
                  window.open(
                    "tel:+390890977647"
                    // <- This is what makes it open in a new window.
                  )
                }
              >
                <div className="icon">
                  <Phone />
                </div>
                <div className="text">
                  <p className="main">089 0977647</p>
                  <p className="secondary">Contattaci per ogni dubbio!</p>
                </div>
              </div>
              <div
                className="item"
                onClick={() =>
                  window.open(
                    "mailto:info@revoluce.it"
                    // <- This is what makes it open in a new window.
                  )
                }
              >
                <div className="icon">
                  <Email />
                </div>
                <div className="text">
                  <p className="main">info@revoluce.it</p>
                  <p className="secondary">Scrivici per ogni perplessità.</p>
                </div>
              </div>
              <div className="item">
                <div className="icon">
                  <Coffee />
                </div>
                <div className="text">
                  <p className="main">Siamo a Salerno</p>
                  <p className="secondary">
                    Via S. Leonardo - 51,
                    <br />
                    Prendiamo un caffè?
                  </p>
                </div>
              </div>
            </div>
            <div className="buttonBox">
                <button onClick={() => section ? navigate("/enrica/gas")  : navigate("/enrica")}>
                    <p>Home</p>
                    <ArrowForwardIos />
                </button>
            </div>
            {/* <div className="tutor">
              <h2>Preferisci farti richiamare da un nostro tutor? </h2>
            </div>
            <button
              onClick={() =>
                window.open(
                  "https://my.revoluce.it/appuntamento",
                  "_blank" // <- This is what makes it open in a new window.
                )
              }
            >
              Prenota un appuntamento <ArrowForwardIosIcon />
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Errore;
